/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module DiagramModules
 */

import {
    AfterViewInit,
    Component,
    ElementRef,
    EventEmitter,
    Input,
    Output,
    Renderer2,
    ViewChild,
} from '@angular/core';

import './avi-legend.component.less';
import 'ajs/less/themes/default-theme/global-ui-variables.less';
import { ILabelData } from '../label-color-optional';

/**
 * @description
 *      Reusable component for avi legend.
 * @author Deepak Chaudhary
 */
@Component({
    selector: 'avi-legend',
    templateUrl: './avi-legend.component.html',
})
export class AviLegendComponent implements AfterViewInit {
    @Input()
    public readonly labelData: ILabelData;

    @Output()
    public toggleLegends = new EventEmitter<ILabelData>();

    @ViewChild('colorIcon')
    public colorIcon: ElementRef;

    constructor(
        private renderer: Renderer2,
    ) { }

    /** @override */
    public ngAfterViewInit(): void {
        this.updateLegends();
    }

    public handleLegendClick(): void {
        this.labelData.isHidden = !this.labelData.isHidden;
        this.toggleLegends.emit(this.labelData);
        this.updateLegends();
    }

    private updateLegends(): void {
        if (!this.labelData.color) {
            return;
        }

        this.renderer.setStyle(
            this.colorIcon.nativeElement,
            'border-color',
            this.labelData.color,
        );

        if (this.labelData.isHidden) {
            this.renderer.setStyle(
                this.colorIcon.nativeElement,
                'background-color',
                'var(--cds-global-color-white)',
            );
        } else {
            this.renderer.setStyle(
                this.colorIcon.nativeElement,
                'background-color',
                this.labelData.color,
            );
        }
    }
}
